export enum ResultTypeEnum {
    Success,
    Failure,
    ExpectedFailure
}